import { Component, OnInit, Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedDataService } from '@teem/services/shared-data.service';
import { LoaderService } from '@teem/services/loader.service';
import { UserService } from '@teem/services/user.service';

import SignaturePad from 'signature_pad';

import { messages as i18n } from '@teem/constants/messages';

@Component({
  selector: 'teem-contract-modal',
  templateUrl: './teem-contract-modal.component.html',
  styleUrls: ['./teem-contract-modal.component.css']
})
export class TeemContractModalComponent implements OnInit {
  @Input() userDetails: any;
  @Input() contractFromData: any;
  @Input() paymentGateWay: string = 'tap';
  @Input() bankName: string = '';

  @ViewChild('sPad', { static: true }) signaturePadElement;
  signaturePad: any;
  i18nMessage: any = i18n;
  now = Date.now();
  oneYearLater = new Date(this.now);
  contractForm = {} as any;
  locale: string = 'en';
  jobTitle : string = '';
  countries: any = { 682: 'Saudi Arabia', 784: 'United Arab Emirates', 414: 'Kuwait' };
  currencies: any = { 682: 'SAR', 784: 'AED', 414: 'KWD' };
  today: Date = new Date();

  canvas!: ElementRef<HTMLCanvasElement>;
  signatureImage: string | null = null;
  teemSignature: string = 'data:image/png;base64,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';

  constructor(
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService,
    public activeModal: NgbActiveModal,
    private el: ElementRef,
    private userService: UserService,
    private modalService: NgbModal,
  ) {
    // el.nativeElement.id = 'fatoorahcontract';
    // el.nativeElement.classList.add('fatoorah-contract');
  }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
    this.oneYearLater.setFullYear(this.oneYearLater.getFullYear() + 1);
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
  }

  clear() {
    this.signaturePad.clear();
  }

  updatePreview() {
    // const canvasEl = this.canvas.nativeElement;
    this.signatureImage = this.signaturePad.toDataURL();
  }

  download(dataURL, filename) {
    if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      window.open(dataURL);
    } else {
      const blob = this.dataURLToBlob(dataURL);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
    }
  }

  dataURLToBlob(dataURL) {
    // Code taken from https://github.com/ebidel/filer.js
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }

  submitContract() {
    if (!this.jobTitle) {
      Swal.fire(i18n.alert.warning, 'Please provide a job title.', 'warning')
    } else if (this.signaturePad.isEmpty()) {
      Swal.fire(i18n.alert.warning, 'Please provide a signature first.', 'warning')
    } else {
      const dataURL = this.signaturePad.toDataURL();

      this.contractForm.sign_image = this.signaturePad.toDataURL();
      this.contractForm.uuid = this.userDetails?.tap_info.uuid; 
      this.contractForm.paymentGateWay = this.paymentGateWay;
      this.contractForm.contractFromData = this.contractFromData;
      this.contractForm.contractFromData.job_title = this.jobTitle;
      this.contractForm.userDetails = this.userDetails;
      
      this.loaderService.startLoading();
      this.userService.storeTeemContract(this.contractForm, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();
          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            Object.assign(userInfo, res.user);
            Object.assign(this.userDetails, res.user);
            this.sharedDataService.setItem('userInfo', userInfo);
          }
          this.activeModal.close(res);
          // Swal.fire(
          //   i18n.hyperpay.your_can_now_receive_online_payments,
          //   i18n.hyperpay.you_can_now_offer_your_customers_payment_using,
          //   'success'
          // );
        },
        (err) => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      );
    }
  }

}
